import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../App/redux/store';
import { APIStatus } from '../../services/axiosEnums';
import {
  createFolderThunk,
  deleteFolderThunk,
  fetchFoldersThunk,
  updateFolderThunk,
} from './services/foldersThunks';

const initialState: FoldersState = {
  folders: { apiStatus: APIStatus.IDLE, result: null, error: undefined },
  deleteModal: null,
};

const foldersSlice = createSlice({
  name: 'folders',
  initialState,
  reducers: {
    setDeleteFolderModal: (state, action: PayloadAction<IFolder | null>) => {
      state.deleteModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFoldersThunk.pending, (state) => {
        state.folders.apiStatus = APIStatus.PENDING;
        state.folders.error = undefined;
      })
      .addCase(
        fetchFoldersThunk.fulfilled,
        (state, action: PayloadAction<Folders>) => {
          state.folders.apiStatus = APIStatus.IDLE;
          state.folders.result = action.payload;
          state.folders.error = undefined;
        },
      )
      .addCase(fetchFoldersThunk.rejected, (state, action) => {
        state.folders.apiStatus = APIStatus.REJECTED;
        state.folders.error = action.error;
      });
    builder
      .addCase(createFolderThunk.pending, (state) => {
        state.folders.apiStatus = APIStatus.PENDING;
        state.folders.error = undefined;
      })
      .addCase(
        createFolderThunk.fulfilled,
        (state, action: PayloadAction<IFolder>) => {
          state.folders.apiStatus = APIStatus.IDLE;
          state.folders.result = state.folders.result
            ? state.folders.result.concat(action.payload)
            : [action.payload];
          state.folders.error = undefined;
        },
      )
      .addCase(createFolderThunk.rejected, (state, action) => {
        state.folders.apiStatus = APIStatus.REJECTED;
        state.folders.error = action.error;
      });
    builder
      .addCase(updateFolderThunk.pending, (state) => {
        state.folders.apiStatus = APIStatus.PENDING;
        state.folders.error = undefined;
      })
      .addCase(
        updateFolderThunk.fulfilled,
        (state, action: PayloadAction<IFolder>) => {
          state.folders.apiStatus = APIStatus.IDLE;
          state.folders.result =
            state.folders.result?.map((m) =>
              m.idIri === action.payload.idIri ? action.payload : m,
            ) ?? null;

          state.folders.error = undefined;
        },
      )
      .addCase(updateFolderThunk.rejected, (state, action) => {
        state.folders.apiStatus = APIStatus.REJECTED;
        state.folders.error = action.error;
      });
    builder
      .addCase(deleteFolderThunk.pending, (state) => {
        state.folders.apiStatus = APIStatus.PENDING;
        state.folders.error = undefined;
      })
      .addCase(
        deleteFolderThunk.fulfilled,
        (state, action: PayloadAction<IFolder>) => {
          state.folders.apiStatus = APIStatus.IDLE;

          state.folders.result =
            state.folders.result?.filter((f) => f.idIri !== action.payload.idIri) ??
            null;

          state.folders.error = undefined;
        },
      )
      .addCase(deleteFolderThunk.rejected, (state, action) => {
        state.folders.apiStatus = APIStatus.REJECTED;
        state.folders.error = action.error;
      });
  },
});

export default foldersSlice.reducer;
export const foldersActions = foldersSlice.actions;
export const getFoldersState = (state: RootState) => state.folders;
